export const voucherConstants = {
    ADD_VOUCHER_REQUEST:              'ADD_VOUCHER_REQUEST',
    ADD_VOUCHER_SUCCESS:              'ADD_VOUCHER_SUCCESS',
    ADD_VOUCHER_FAILURE:              'ADD_VOUCHER_FAILURE',

    GET_DEAL_VOUCHER_REQUEST:         'GET_DEAL_VOUCHER_REQUEST',
    GET_DEAL_VOUCHER_SUCCESS:         'GET_DEAL_VOUCHER_SUCCESS',
    GET_DEAL_VOUCHER_FAILURE:         'GET_DEAL_VOUCHER_FAILURE',

    GET_VOUCHER_REQUEST:            'GET_VOUCHER_REQUEST',
    GET_VOUCHER_SUCCESS:            'GET_VOUCHER_SUCCESS',
    GET_VOUCHER_FAILURE:            'GET_VOUCHER_FAILURE',

    REDEEM_VOUCHER_REQUEST:         'REDEEM_VOUCHER_REQUEST',
    REDEEM_VOUCHER_SUCCESS:         'REDEEM_VOUCHER_SUCCESS',
    REDEEM_VOUCHER_FAILURE:          'REDEEM_VOUCHER_FAILURE',

    CHECK_EMAIL_REQUEST:        'CHECK_EMAIL_REQUEST',
    CHECK_EMAIL_SUCCESS:        'CHECK_EMAIL_SUCCESS',
    CHECK_EMAIL_FAILURE:        'CHECK_EMAIL_FAILURE',

    AUTO_EMAIL_REQUEST:         'AUTO_EMAIL_REQUEST',
    AUTO_EMAIL_SUCCESS:         'AUTO_EMAIL_SUCCESS',
    AUTO_EMAIL_FAILURE:         'AUTO_EMAIL_FAILURE',

    CHECK_QTY_REQUEST:         'CHECK_QTY_REQUEST',
    CHECK_QTY_SUCCESS:         'CHECK_QTY_SUCCESS',
    CHECK_QTY_FAILURE:         'CHECK_QTY_FAILURE',

    UPDATE_STATUS_REQUEST:      'UPDATE_STATUS_REQUEST',
    UPDATE_STATUS_SUCCESS:      'UPDATE_STATUS_SUCCESS',
    UPDATE_STATUS_FAILURE:      'UPDATE_STATUS_FAILURE',

    GET_MERCHANT_DEAL_REQUEST:   'GET_MERCHANT_DEAL_REQUEST',
    GET_MERCHANT_DEAL_SUCCESS:      'GET_MERCHANT_DEAL_SUCCESS',
    GET_MERCHANT_DEAL_FAILURE:      'GET_MERCHANT_DEAL_FAILURE',

    GET_MERCHANT_VOUCHER_REQUEST:       'GET_MERCHANT_VOUCHER_REQUEST',
    GET_MERCHANT_VOUCHER_SUCCESS:       'GET_MERCHANT_VOUCHER_SUCCESS',
    GET_MERCHANT_VOUCHER_FAILURE:        'GET_MERCHANT_VOUCHER_FAILURE',

    GET_VOUCHER_DETAIL_REQUEST:             'GET_VOUCHER_DETAIL_REQUEST',
    GET_VOUCHER_DETAIL_SUCCESS:             'GET_VOUCHER_DETAIL_SUCCESS',
    GET_VOUCHER_DETAIL_FAILURE:             'GET_VOUCHER_DETAIL_FAILURE',

    EDIT_VOUCHER_REQUEST:               'EDIT_VOUCHER_REQUEST',
    EDIT_VOUCHER_SUCCESS:               'EDIT_VOUCHER_SUCCESS',
    EDIT_VOUCHER_FAILURE:           'EDIT_VOUCHER_FAILURE',

    GET_MERCHANT_ALLVOUCHER_REQUEST:  'GET_MERCHANT_ALLVOUCHER_REQUEST',
    GET_MERCHANT_ALLVOUCHER_SUCCESS:  'GET_MERCHANT_ALLVOUCHER_SUCCESS',
    GET_MERCHANT_ALLVOUCHER_FAILURE:   'GET_MERCHANT_ALLVOUCHER_FAILURE',

    UPLOAD_TRACKING_NO_REQUEST:     'UPLOAD_TRACKING_NO_REQUEST',
    UPLOAD_TRACKING_NO_SUCCESS:     'UPLOAD_TRACKING_NO_SUCCESS',
    UPLOAD_TRACKING_NO_FAILURE:      'UPLOAD_TRACKING_NO_FAILURE',

    GET_UPLOAD_TRACKING_HISTORY_REQUEST:        'GET_UPLOAD_TRACKING_HISTORY_REQUEST',
    GET_UPLOAD_TRACKING_HISTORY_SUCCESS:         'GET_UPLOAD_TRACKING_HISTORY_SUCCESS',
    GET_UPLOAD_TRACKING_HISTORY_FAILURE:         'GET_UPLOAD_TRACKING_HISTORY_FAILURE',

    EXPORT_PURCHASER_LIST_REQUEST:     'EXPORT_PURCHASER_LIST_REQUEST',
    EXPORT_PURCHASER_LIST_SUCCESS:      'EXPORT_PURCHASER_LIST_SUCCESS',
    EXPORT_PURCHASER_LIST_FAILURE:      'EXPORT_PURCHASER_LIST_FAILURE',
    VOUCHER_TRANSFER_REQUEST:           'VOUCHER_TRANSFER_REQUEST',
    VOUCHER_TRANSFER_SUCCESS:           'VOUCHER_TRANSFER_SUCCESS',
    VOUCHER_TRANSFER_FAILURE:           'VOUCHER_TRANSFER_FAILURE',
    POST_REFUND_REQUEST:                'POST_REFUND_REQUEST',
    POST_REFUND_SUCCESS:                'POST_REFUND_SUCCESS',
    POST_REFUND_FAILURE:                'POST_REFUND_FAILURE',

    GET_ORDER_HISTORY_REQUEST:          'GET_ORDER_HISTORY_REQUEST',
    GET_ORDER_HISTORY_SUCCESS:          'GET_ORDER_HISTORY_SUCCESS',
    GET_ORDER_HISTORY_FAILURE:          'GET_ORDER_HISTORY_FAILURE',

    POST_VOUCHERSTATUS_REQUEST:         'POST_VOUCHERSTATUS_REQUEST',
    POST_VOUCHERSTATUS_SUCCESS:         'POST_VOUCHERSTATUS_SUCCESS',
    POST_VOUCHERSTATUS_FAILURE:         'POST_VOUCHERSTATUS_FAILURE',

    POST_RESEND_REQUEST:                'POST_RESEND_REQUEST',
    POST_RESEND_SUCCESS:                'POST_RESEND_SUCCESS',
    POST_RESEND_FAILURE:                'POST_RESEND_FAILURE',
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/voucherConstants.js